module.exports = __webpack_public_path__ + "img/Jrcode.93bb0a8e.png";